var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.6051V15.6051C22 15.8251 22 16.0451 21.98 16.2551C21.16 15.2451 19.91 14.6051 18.5 14.6051C17.44 14.6051 16.46 14.9751 15.69 15.5951C14.65 16.4151 14 17.6851 14 19.1051C14 20.5151 14.64 21.7651 15.65 22.5851C15.44 22.6051 15.22 22.6051 15 22.6051H9C4 22.6051 2 20.6051 2 15.6051V9.6051C2 4.6051 4 2.6051 9 2.6051H15C20 2.6051 22 4.6051 22 9.6051Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.51953 7.71509H21.4796",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51953 2.71509V7.57507",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4805 2.71509V7.12512",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19.1051C23 20.4551 22.4 21.6551 21.47 22.4851C20.67 23.1751 19.64 23.6051 18.5 23.6051C17.42 23.6051 16.42 23.2251 15.65 22.5851C14.64 21.7651 14 20.5151 14 19.1051C14 17.6851 14.65 16.4151 15.69 15.5951C16.46 14.9751 17.44 14.6051 18.5 14.6051C19.91 14.6051 21.16 15.2451 21.98 16.2551C22.62 17.0251 23 18.0251 23 19.1051Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7809 17.6951V19.3851L17.3809 20.2251",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoTime);
export default __webpack_public_path__ + "static/media/video-time.a82e69eafd791a19bb44bfdb1b0d7ab8.svg";
export { ForwardRef as ReactComponent };